import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Archive, Thermometer, AlertCircle, CheckSquare } from 'lucide-react';
import { Button } from './ui/Button';
const items = [{
  icon: BookOpen,
  title: 'eBook Maestro S.O.S. Insomnio Masculino',
  desc: 'La guía paso a paso con el protocolo completo.'
}, {
  icon: Archive,
  title: 'El Método de Vaciado "Caja Negra"',
  desc: 'La técnica exacta para sacar los problemas de tu cabeza y dejarlos en papel antes de tocar la almohada.'
}, {
  icon: Thermometer,
  title: 'Protocolo de Higiene Térmica 90-10',
  desc: 'Cómo manipular la temperatura de tu cuerpo para disparar la melatonina natural.'
}, {
  icon: AlertCircle,
  title: 'La Regla de Triaje de las 3 AM',
  desc: 'Qué hacer exactamente cuando te despiertas a media noche para no arruinar el resto del descanso.'
}, {
  icon: CheckSquare,
  title: 'Checklist de Habitación Blindada',
  desc: 'Una lista de verificación para eliminar los "secuestradores del sueño" de tu dormitorio hoy mismo.'
}];
export function WhatYouGet() {
  return <section className="w-full bg-midnight-deep py-24 px-6 border-y border-cyan-signal/10" data-id="element-211">
      <div className="max-w-5xl mx-auto" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-213">
          <h2 className="font-display text-3xl md:text-5xl text-bone uppercase leading-tight" data-id="element-214">
            Lo que recibes hoy
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start mb-16" data-id="element-215">
          <motion.div className="lg:col-span-5 hidden lg:block sticky top-24" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-216">
            <img src="https://cdn.magicpatterns.com/uploads/csFt1e6LnfV1hpmHvacF7z/IM1.png" alt="S.O.S. Insomnio Masculino" className="w-full h-auto object-contain drop-shadow-2xl opacity-90" data-id="element-217" />
          </motion.div>

          <div className="lg:col-span-7 space-y-6" data-id="element-218">
            {items.map((item, index) => {
            const Icon = item.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.1
            }} className="bg-midnight p-6 border border-cyan-signal/10 flex gap-6 items-start hover:border-cyan-signal/30 transition-colors" data-id="element-219">
                  <div className="flex-shrink-0 w-12 h-12 bg-cyan-signal/10 flex items-center justify-center" data-id="element-220">
                    <Icon className="w-6 h-6 text-cyan-signal" data-id="element-221" />
                  </div>
                  <div data-id="element-222">
                    <h3 className="text-lg font-bold text-bone mb-2 uppercase tracking-wide" data-id="element-223">
                      {item.title}
                    </h3>
                    <p className="text-steel leading-relaxed" data-id="element-224">{item.desc}</p>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex justify-center" data-id="element-225">
          <Button href="#oferta" subtext="Acceso inmediato · Pago único de $27" data-id="element-226">
            Mándame el Protocolo Ahora
          </Button>
        </motion.div>
      </div>
    </section>;
}